export default __webpack_public_path__ + "static/media/mastercard.b854df96.png";